import React           from 'react';
import { Observe }     from 'rewire-core';
import InfoPanelFooter from '../ui/InfoPanelFooter';
import SettingsModel   from './SettingsModel';

export const BillingEditPanelFooterView = ({ settings, classes }: { settings: SettingsModel, classes?: any }) => (
  <Observe render={() => (
    settings.editor && settings.selectedItem
      ? <InfoPanelFooter isDisabled={settings.editor.isDisabled} actions={{manage: settings.editor.actions.manage}} classes={classes} />
      : null
  )} />
);